import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%'
  },
  paper: {
    width: '100%',
    marginBottom: theme.spacing(2)
  },
  table: {
    minWidth: theme.spacing(90),
    tableLayout: 'fixed'
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1
  },
  container: {
    width: '100%',
    //marginTop: theme.spacing(1)
    overflowAnchor: 'none'
  },
  legend: {
    width: '30%',
    justifyContent: 'space-between',
    display: 'flex',
    flexDirection: 'row'
  },
  flexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  hashtag: {
    paddingLeft: theme.spacing(1)
  },
  thumbUp: {
    color: theme.palette.success.main
  },
  thumbDown: {
    color: theme.palette.error.main
  },
  netral: {
    color: theme.palette.primary.main
  },
  sentimentOptions: {
    cursor: 'pointer'
  },
  iconSentiment: {
    height: theme.spacing(5),
    width: theme.spacing(5)
  },
  centerItem: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  containerLoading: {
    height: 'calc(100vh - 420px)',
    background: theme.palette.grey[200],
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.palette.grey[200],
    opacity: '0.3'
  },
  containerEmpty: {
    height: 'calc(100vh - 420px)',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  loading: {
    color: theme.palette.primary.main
  },
  editIcon: {
    width: theme.spacing(2),
    height: theme.spacing(2),
    backgroundColor: theme.palette.primary.main,
    cursor: 'pointer',
    margin: '2px 0px 2px 4px'
  },
  hidden: {
    //position: "absolute",
    display: 'none',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    height: '1px',
    width: '1px',
    margin: '-1px',
    padding: 0,
    border: 0
  },
  parentSearch: {
    width: '100%'
  },
  disable: {
    backgroundColor: theme.palette.action.hover
  },
  z0: {
    zIndex: 0
  },
  pagination: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    padding: theme.spacing(3)
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: theme.spacing(10)
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignContent: 'center'
  },
  mr2: {
    marginRight: theme.spacing(2)
  },
  mr3: {
    marginRight: theme.spacing(3)
  },
  elipsis: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    width: '100%'
  }
}));

export default useStyles;
